/*
 *  @author Davi Wegner
 *  @email davi@easypro.com.br
 *  @date 04/02/2021
 **/

export const checkNameOnList = (name, list?, idField?) => {
    const language = localStorage.getItem('language') || 'br';
    const copyWord = language == 'br' ? 'Cópia' : 'Copy';

    if (list)
      return list.reduce((acc, crr) => {
        if (acc === crr[idField]) acc = acc + " - " + copyWord;
        return acc;
      }, name);
    else return name;
  },
  copyEmails = (emails) => {
    if (emails)
      return emails.map(({ QuestionEmailEntity, ...otherProps }) => ({
        email_id: otherProps.id,
        ...otherProps,
      }));
  },
  copyUnconformity = (unconformities) => {
    if (unconformities)
      return unconformities.map(
        ({ QuestionUnconformityEntity, ...otherProps }) => otherProps
      );
  },
  copyQuestion = (question, questions?, isCopy?) => {
    const {
      id,
      emails,
      unconformities,
      description,
      origin_id,
      previous_id,
      question_group_id,
      ...otherProps
    } = question;

    return {
      ...generateVersionItems({ id, previous_id, origin_id }, isCopy),
      ...otherProps,
      question_group_id: isCopy ? null : question_group_id,
      description: checkNameOnList(description, questions, "description"),
      unconformities: copyUnconformity(unconformities),
      emails: copyEmails(emails),
    };
  },
  copyQuestionGroup = (questionGroup, questionGroups, isCopy?) => {
    let {
      name,
      weight,
      checklist_id,
      attachment,
      questions,
      item_order,
      id,
      previous_id,
      origin_id,
    } = questionGroup;
    // // console.log(questionGroup)
    // console.log(item_order)
    // console.log(questionGroup)
    // console.log(questionGroups)
    return {
      ...generateVersionItems({ id, previous_id, origin_id }, isCopy),
      attachment,
      name: checkNameOnList(name, questionGroups, "name"),
      item_order,
      weight,
      checklist_id,
      questions: questions.map(({ question_group_id, ...otherProps }) =>
        copyQuestion(otherProps, null, isCopy)
      ),
    };
  },
  copyChecklist = (checklist, isCopy) => {
    const { emails, question_groups, ...otherProps } = checklist;
    // console.log(generateVersion(otherProps, isCopy))
    return {
      emails: copyEmails(emails),
      question_groups: question_groups.map(
        ({ id, checklist_id, questions, ...otherProps }) => ({
          ...otherProps,
          questions: questions.map(({ id, ...otherProps }) => ({
            ...copyQuestion(otherProps, null, isCopy),
          })),
        })
      ),
      // ...otherProps,
      ...generateVersion(otherProps, isCopy),
    };
  },
  generateVersion = (checklist, isCopy) => {
    const { id, origin_id, version, previous_id, ...otherProps } = checklist;
    return {
      ...otherProps,
      previous_id: isCopy ? null : id,
      origin_id: isCopy ? null : (origin_id ? origin_id : id),
      active: true,
      version: isCopy ? null : version,
    };
  },
  generateVersionItems = (item, isCopy) => {
    const { id, origin_id, previous_id, ...otherProps } = item;
    if (!isCopy)
      return {
        ...otherProps,
        previous_id: id,
        origin_id: origin_id ? origin_id : id,
      };
  };



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/utils.ts